import React, { useContext, useEffect } from "react";
import {
  DispatchContext,
  StateContext,
} from "bodycodi/cmap/app/components/cmap2010/calendar/calendar";
import { Swiper, SwiperSlide } from "swiper/react";
import { isEmpty } from "bodycodi/cmap/app/js/common";

import GridCalendar from "bodycodi/cmap/app/components/cmap2010/calendar/gridCalendar";

interface CalendarList {
  isAddStep: boolean;
  chooseDate: any;
}

const CalendarList = ({ isAddStep, chooseDate }: CalendarList) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { swiper, calenderDateList } = state;

  useEffect(() => {
    if (!isEmpty(swiper)) {
      swiper.update();
    }
  }, [calenderDateList]);

  const setSwiper = (swiper: any) => {
    dispatch({ type: "UPDATE", data: { swiper: swiper } });
  };

  const slideChange = () => {
    if (!isEmpty(state.swiper)) {
      const index = state.swiper.activeIndex;
      const prevIndex = state.swiper.previousIndex;
      dispatch({ type: "UPDATE", data: { index: index, prevIndex: prevIndex } });
    }
  };

  return (
    <div className="calendar-body">
      <Swiper
        onSwiper={(swiper) => {
          setSwiper(swiper);
        }}
        onSlideChange={slideChange}
        initialSlide={isAddStep ? 0 : 5}
      >
        {state.calenderDateList.map((d: Date) => (
          <SwiperSlide key={`${d.getFullYear()}-${d.getMonth()}`}>
            {({ isActive }) => (
              <GridCalendar
                clndrDate={`${d.getFullYear()}-${d.getMonth()}`}
                isActive={isActive}
                chooseDate={chooseDate}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CalendarList;
